

















import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component({
  name: 'GoogleMapLink'
})

export default class GoogleMapLink extends Vue {

  get googleMapLink() {
    const lat = this.$store.state.activeSite.reference.lat;
    const lon = this.$store.state.activeSite.reference.lon;
    return `https://maps.google.com/?q=${lat},${lon}`
  }

  get latLonDisplayText() {
    const lat = this.$store.state.activeSite.reference.lat;
    const lon = this.$store.state.activeSite.reference.lon;
    return `(${lat}, ${lon})`
  }

}

